"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NON_EMPLOYMENT_SUB_TYPES = exports.PROPERTY_RENTAL = exports.DISABILITY = exports.HOUSEHOLD_CONTRIBUTIONS = exports.OTHER = exports.PENSION_RETIREMENT = exports.OTHER_GOV_ASSISTANCE = exports.SOCIAL_SECURITY = exports.UNEMPLOYMENT = exports.FAMILY_SUPPORT = exports.INTERESTS_DIVIDENDS_ROYALTIES = exports.BUSINESS_PROFESSIONAL_FARM = exports.EMPLOYMENT_SUB_TYPES = exports.SELF_EMPLOYED = exports.PART_TIME = exports.FULL_TIME = void 0; // Employment Sub-Types

var FULL_TIME = 'full_time';
exports.FULL_TIME = FULL_TIME;
var PART_TIME = 'part_time';
exports.PART_TIME = PART_TIME;
var SELF_EMPLOYED = 'self_employed';
exports.SELF_EMPLOYED = SELF_EMPLOYED;
var EMPLOYMENT_SUB_TYPES = [FULL_TIME, PART_TIME, SELF_EMPLOYED]; // Non-Employment Sub-Types

exports.EMPLOYMENT_SUB_TYPES = EMPLOYMENT_SUB_TYPES;
var BUSINESS_PROFESSIONAL_FARM = 'business_professional_farm';
exports.BUSINESS_PROFESSIONAL_FARM = BUSINESS_PROFESSIONAL_FARM;
var INTERESTS_DIVIDENDS_ROYALTIES = 'interests_dividends_royalties';
exports.INTERESTS_DIVIDENDS_ROYALTIES = INTERESTS_DIVIDENDS_ROYALTIES;
var FAMILY_SUPPORT = 'family_support';
exports.FAMILY_SUPPORT = FAMILY_SUPPORT;
var UNEMPLOYMENT = 'unemployment';
exports.UNEMPLOYMENT = UNEMPLOYMENT;
var SOCIAL_SECURITY = 'social_security';
exports.SOCIAL_SECURITY = SOCIAL_SECURITY;
var OTHER_GOV_ASSISTANCE = 'other_gov_assistance';
exports.OTHER_GOV_ASSISTANCE = OTHER_GOV_ASSISTANCE;
var PENSION_RETIREMENT = 'pension_retirement';
exports.PENSION_RETIREMENT = PENSION_RETIREMENT;
var OTHER = 'other';
exports.OTHER = OTHER;
var HOUSEHOLD_CONTRIBUTIONS = 'household_contributions';
exports.HOUSEHOLD_CONTRIBUTIONS = HOUSEHOLD_CONTRIBUTIONS;
var DISABILITY = 'disability'; // Not sure if this is info matters elsewhere besides schedule I non-employment

exports.DISABILITY = DISABILITY;
var PROPERTY_RENTAL = 'property_rental'; // Distinguish rental/Airbnb income for means test

exports.PROPERTY_RENTAL = PROPERTY_RENTAL;
var NON_EMPLOYMENT_SUB_TYPES = [BUSINESS_PROFESSIONAL_FARM, PROPERTY_RENTAL, INTERESTS_DIVIDENDS_ROYALTIES, FAMILY_SUPPORT, UNEMPLOYMENT, SOCIAL_SECURITY, OTHER_GOV_ASSISTANCE, PENSION_RETIREMENT, OTHER, HOUSEHOLD_CONTRIBUTIONS];
exports.NON_EMPLOYMENT_SUB_TYPES = NON_EMPLOYMENT_SUB_TYPES;